import { AnyAction } from 'redux';
import { ActionTypes } from '../actions/ActionTypes';
import {FaqDto, MenuDto} from 'src/services/Client';

export interface ISupportState {
  /** Support area links */
  supportAreaLinks?: MenuDto;
  activeFaqs: FaqDto[];
}

const INITIAL_STATE: ISupportState = {
  supportAreaLinks: undefined,
  activeFaqs: []
};

export const supportReducer = (
  state: ISupportState = INITIAL_STATE,
  action: AnyAction
): ISupportState => {
  switch (action.type) {
    case ActionTypes.RECEIVE_SUPPORTAREA_LINKS:
      return {
        ...state,
        supportAreaLinks: action.supportAreaLinks,
      };
    case ActionTypes.RECEIVE_ACTIVE_FAQS:
      return {
        ...state,
        activeFaqs: action.activeFaqs,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/supportReducer.ts